module.exports = __webpack_public_path__ + "img/csomagjaink_bg_372.302a8b74.png";